exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".checked-select[data-v-da6d99f4]{color:#17ad9f;font-weight:700}.el-tree[data-v-da6d99f4] .custom-tree-node{display:flex}", "", {"version":3,"sources":["/home/www/deploy/school/src/components/catalog/compress.vue"],"names":[],"mappings":"AACA,iCACE,cAAe,AACf,eAAkB,CACnB,AACD,4CACE,YAAc,CACf","file":"compress.vue","sourcesContent":["\n.checked-select[data-v-da6d99f4] {\n  color: #17ad9f;\n  font-weight: bold;\n}\n.el-tree[data-v-da6d99f4] .custom-tree-node {\n  display: flex;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da6d99f4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/catalog/compress.vue
// module id = 3YQM
// module chunks = 28